import productManager from './product-manager'

export default productManager
